/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, forwardRef } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import SoftButton from "components/SoftButton";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { useSoftUIController, setDrivers, setSelectedDriver } from "context";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import { addDriver } from 'actions';

function UnassignedDrivers(props) {
  const [controller, dispatch] = useSoftUIController();
  const [toaster, setToaster] = useState(false);

  let { drivers, selectedDriver } = props;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToaster(false);
  };

  return (
    <Card>
      <SoftBox p={2}>
        <Grid container spacing={3}>
          <Grid item lg={12}>
            <SoftBox display="flex" flexDirection="column" height="100%">
              <SoftTypography variant="body2" color="text">
                Select an employee to add them to the list of available drivers
              </SoftTypography>
              <Grid item lg={12}>
                <Autocomplete
                  id="available_users"
                  onChange={(e, value) => setSelectedDriver(dispatch, value)}
                  options={drivers.filter(d => !d.driver)}
                  sx={{ width: 300, marginTop: '20px' }}
                  renderInput={(params) => { return <TextField {...params} label=" " /> }}
                />
              </Grid>
              <Grid item lg={6} style={{ marginTop: '20px' }}>
                <SoftButton onClick={() => {
                  if (selectedDriver) {
                    addDriver(selectedDriver).then(sd => {
                      setDrivers(dispatch, drivers.map(d => d.email === sd.email ? { ...sd, driver: 1 } : d));
                      setSelectedDriver(dispatch, null);
                      setToaster(true);
                    });
                  }
                  else {
                    alert('You must select a driver to add');
                  }
                }}>Submit</SoftButton>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
      <Snackbar open={toaster} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          The operation completed successfully!
        </Alert>
      </Snackbar>
    </Card>
  );
}

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default UnassignedDrivers;
